<button
  nz-button
  [nzSize]="size"
  class="rounded font-bold items-center flex"
  [ngClass]="buttonColorClass"
  [disabled]="disabled"
  (click)="handleClick()"
  nzType="default"
>
  <ng-content></ng-content>
</button>
